<!--
 * @Descripttion: 超佣团平台类目筛选，包括达人主推类目，商品类目，抖音平台映射快手平台类目
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-06 13:37:33
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-13 10:51:30
-->
<template>
	<el-select
		v-bind="$attrs"
		v-model="cate"
		@change="change"
		:disabled="disabled"
		:size="size"
		:placeholder="placeholder"
		:filterable="filterable"
		:clearable="clearable"
		:multiple="multiple"
		:multiple-limit="multipleLimit"
	>
		<el-option v-for="item in list" :key="item.value" :label="item.label" :value="item.value"></el-option>
	</el-select>
</template>
<script>
import { talCategoryList } from '@/api/shopManage';
import { mapGetters } from 'vuex';
export default {
	name: 'YxCategorySelect',
	props: {
		value: [String, Number, Array],
		isGoodsCat: {
			type: Boolean,
			default: false,
		},
		platformId: {
			type: [String, Number],
			default: '',
		},
		addAll: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			cate: this.value,
			optionList: [],
		};
	},
	watch: {
		value(val) {
			this.cate = val;
		},
		platformId() {
			this.getCateList();

			this.cate = '';
			this.change('');
		},
	},
	computed: {
		...mapGetters(['ksCategoryList', 'spCategoryList']),
		disabled() {
			return this.$attrs.disabled || false;
		},
		// 输入框尺寸
		size() {
			return this.$attrs.size;
		},
		// 提示信息
		placeholder() {
			return this.$attrs.placeholder || '请选择商品类目';
		},
		// 是否可搜索
		filterable() {
			return this.$attrs.filterable === false ? this.$attrs.filterable : true;
		},
		//是否可以清空选项
		clearable() {
			return this.$attrs.clearable || false;
		},
		multiple() {
			return this.$attrs.multiple || false;
		},
		multipleLimit() {
			return this.$attrs['multiple-limit'] || 0;
		},
		list() {
			const { optionList, addAll } = this;
			if (addAll) return [{ label: '全部', value: '' }, ...optionList];
			return optionList;
		},
	},
	methods: {
		change(val) {
			this.$emit('input', val);
			this.$emit('change', val);
		},
		async getCateList() {
			if (this.$isDy(this.platformId)) {
				this.getTalCategoryList();
			}
			if (this.$isKs(this.platformId)) {
				if (this.isGoodsCat) {
					this.optionList = this.ksCategoryList;
				} else {
					this.getTalCategoryList();
				}
			}
			if (this.$isSp(this.platformId)) {
				this.optionList = this.spCategoryList;
			}
		},
		async getTalCategoryList() {
			const {
				code,
				data: { list = [] },
			} = await talCategoryList({ platform_id: this.platformId });
			if (code === 0) {
				this.optionList = list.map(({ labelId, name }) => ({ label: name, value: labelId }));
			}
		},
	},
	mounted() {
		this.getCateList();
	},
};
</script>
